import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import SmoothScroll from "@/components/SmoothScroll";
import LandingPage from "@/pages/LandingPage";
import BookingPage from "@/pages/BookingPage";
import AdminPage from "@/pages/AdminPage";
import FleetPage from "@/pages/FleetPage";
import FleetProposalPage from "@/pages/FleetProposalPage";

export default function App() {
  return (
    <div className="App min-h-screen bg-black text-zinc-200">
      <BrowserRouter>
        <SmoothScroll>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/book" element={<BookingPage />} />
            <Route path="/fleet" element={<FleetPage />} />
            <Route path="/fleet/proposal" element={<FleetProposalPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </SmoothScroll>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors closeButton />
    </div>
  );
}
